import { useEffect, useState } from "react";
import { Lightbulb } from "lucide-react";
import { api } from "@/lib/api";

export const CarteSouffleur = ({ s, titre = "Souffleur", testId = "prompter-card" }) => (
  <div className="p-3 space-y-1.5 text-sm text-left" style={{ background: "color-mix(in srgb, var(--micro) 22%, transparent)", borderRadius: 16 }} data-testid={testId}>
    <p className="font-bold flex items-center gap-2"><Lightbulb size={15} />{titre} · « {s.objection} »</p>
    {s.message ? <p className="break-words">{s.message}</p> : <p className="break-words">Le client : « {s.dit_par_le_client} »</p>}
    {!s.message && <p className="text-xs at-muted break-words">Réponse donnée : {s.reponse_donnee}</p>}
    <p className="font-semibold break-words" data-testid={`${testId}-advice`}>À dire : « {s.reponse_conseillee} »</p>
    <p className="text-xs at-muted">{s.source} (simulation)</p>
  </div>
);

export const SouffleurOuverture = ({ url, testId }) => {
  const [s, setS] = useState(null);
  useEffect(() => { api.get(url).then((r) => setS(r.data.souffleur)).catch(() => setS(null)); }, [url]);
  if (!s) return null;
  return <CarteSouffleur s={s} titre="Ce qui a bloqué la dernière fois" testId={testId} />;
};
